import { ReactComponent as ViewIcon } from "../../assets/icon/views.svg";
import Button from "../../components/Button";
import { ShareIcon, UsersIcon } from '@heroicons/react/24/outline';
import { fixUrl } from "../../helpers";

const Slide = ({ event }) => {
  const triggerShare = () => {
    const url = `/${event?.url ?? ""}`;

    if (navigator.share) {
      navigator.share({
        title: `Share - {event?.title}`,
        url: url
      })
        .then(() => {
        console.log('Thanks for sharing!');
      })
        .catch(console.error);
    } else {
      navigator.clipboard.writeText(url);
      alert("Event Url Copied!");
    }
  };

  return (
    <div>
      <div className="bg-black mx-4 mt-4 text-white relative h-auto">
        <div className="py-2 px-4">
          <div className="border-2 border-gray-400 absolute -top-4 -inset-x-4 bottom-[10%] -z-10"></div>
          <img
            src={fixUrl(event.imageUrl)}
            alt="flier"
            className="object-cover w-full h-96"
          />
          <div className="mt-5 mb-8">
            <p className="text-xl mb-2 capitalize">{event?.title ?? ""}</p>
            <p className="whitespace-nowrap overflow-hidden text-ellipsis">{event?.subtitle ?? ""}&nbsp;</p>
          </div>
          <div className="flex items-center justify-between mb-2">
            <Button
              text="Create A Banner"
              icon="right-arrow"
              to={`/${event?.url ?? ""}`}
            />

            <button onClick={triggerShare}>
              <ShareIcon className="h-6 w-auto ml-3 text-gray-300" />
            </button>
          </div>
        </div>

        <div className="border-t border-white py-4">
          <div className="flex justify-between w-11/12 mx-auto text-gray-50/60">
            <div className="flex items-center">
              <ViewIcon />
              <span className="mx-2">{event?.numberOfViews ?? 0}</span>
              <span>View{event.numberOfViews === 1 ? "" : "s"}</span>
            </div>
            <div className="flex items-center">
              <UsersIcon className="text-gray-50/40 w-auto h-6" />
              <span className="mx-2">{event?.numberOfDps ?? 0}</span>
              <span>Usage</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Slide;
